export var config = {
  background: '#F5F5F5',
  foreground: '#333333',
  selection: '#C9D0D9',
  selectionMatch: '#C9D0D9',
  cursor: '#54494B',
  dropdownBackground: '#F5F5F5',
  activeLine: '#E4F6D4',
  matchingBracket: '#E4F6D4',
  keyword: '#4B69C6',
  storage: '#4B69C6',
  variable: '#7A3E9D',
  parameter: '#7A3E9D',
  function: '#AA3731',
  string: '#448C27',
  constant: '#9C5D27',
  type: '#7A3E9D',
  class: '#AA3731',
  number: '#9C5D27',
  comment: '#AAAAAA',
  heading: '#AA3731',
  invalid: '#cd3131',
  regexp: '#4B69C6',
  tag: '#4B69C6'
};